import { useCallback, useEffect, useState } from 'react';
const readFromStorage = key => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const useLocalStorage = key => {
  const [storedValue, setStoredValue] = useState(() => readFromStorage(key));
  useEffect(() => {
    const handleStorageChange = event => {
      if (event.key === key) {
        setStoredValue(event.newValue);
      }
    };
    const handleCustomStorageChange = event => {
      const detail = event.detail;
      if ((detail === null || detail === void 0 ? void 0 : detail.key) === key) {
        setStoredValue(detail.newValue);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('local-storage-change', handleCustomStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage-change', handleCustomStorageChange);
    };
  }, [key]);
  const setValue = useCallback(value => {
    try {
      window.localStorage.setItem(key, value);
      setStoredValue(value);
      window.dispatchEvent(new CustomEvent('local-storage-change', {
        detail: {
          key,
          newValue: value
        }
      }));
    } catch (error) {
      console.error(error);
    }
  }, [key]);
  return [storedValue, setValue];
};